import { some } from 'lodash';
import { removeCache } from '@adjust/dashboard-core/lib/serviceWorker/serviceWorker';
import { redirect } from '@adjust/dashboard-core/lib/utils/location';

/**
 * Account settings controller which is parent of nested tabs
 * like your data, invoices, payment methods and so on
 */
function AccountSettingsController($scope, $state, User, Account) {
  'ngInject';

  var vm = this;

  vm.showSubnav = true;
  vm.logout = logout;
  vm.isNewFeatureScopeActive = true;

  Account.getCurrent()
    .then(_initializeNewFeatureScope);

  function _initializeNewFeatureScope(currentAccount) {
    vm.isNewFeatureScopeActive = Account.hasNewFeatureScope(currentAccount);
  }

  $scope.$on('account-settings:active', _handleActiveChange);

  if ($state.includes('accountSettings.payment-setup')) {
    vm.showSubnav = false;
  } else {
    _activateNested();
  }

  /**
   * Check if one of the nested views is loaded, if not redirect to your data page
   *
   * @private
   */
  function _activateNested() {
    var nested = ['account-data', 'users', 'invoices', 'payment-methods', 'account-history', 'addons-packages'];

    var hasNestedActive = some(nested, function(screen) {
      return $state.includes('accountSettings.' + screen);
    });

    if (!hasNestedActive) {
      $state.go('accountSettings.account-data');
    }
  }

  /**
   * Detect acitve tab change
   *
   * @param {Object} e event object
   * @param {String} active active tab
   * @private
   */
  function _handleActiveChange(e, active) {
    vm.active = active;
  }

  function logout() {
    User.logout()
      .then(removeCache(/runtime/))
      .then(() => {
        redirect('/#/login');
      });
  }
}

export { AccountSettingsController };
